import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private sidebarState = new BehaviorSubject<boolean>(true);
  sidebarState$ = this.sidebarState.asObservable();

  private isMobileView = new BehaviorSubject<boolean>(false);
  isMobileView$ = this.isMobileView.asObservable();

  toggleSidebar(): void {
    const newState = !this.sidebarState.value;
    this.sidebarState.next(newState);
  }

  setSidebarState(state: boolean): void {
    this.sidebarState.next(state);
  }

  setMobileView(isMobile: boolean): void {
    this.isMobileView.next(isMobile);
  }

  get currentSidebarState(): boolean {
    return this.sidebarState.value;
  }

  get isMobile(): boolean {
    return this.isMobileView.value;
  }
}
